import { ModalTheme } from './types'

export const light: ModalTheme = {
  background: '#FFFFFF',
}

export const dark: ModalTheme = {
  background: '#FFFFFF',
}
